import API from '../api/index';
export const getVersion = () => API.get('/version');